export function parseAndFormatArtworkGeometry(size, sourceArtworkGeometryInPixels) {
  const [width, height] = size.split("x");
  const printGeometry = { width, height };
  return calculateAndFormatArtworkGeometry(printGeometry, sourceArtworkGeometryInPixels);
}

export function calculateAndFormatArtworkGeometry(printableAreaInInches, sourceArtworkGeometryInPixels) {
  const calculatedGeometry = calculateArtworkGeometry(1, printableAreaInInches, sourceArtworkGeometryInPixels);
  return format(calculatedGeometry);
}

export function calculateArtworkGeometry(canvasPixelsPerInch, printableAreaInInches, sourceArtworkGeometryInPixels) {
  const sourceRatio = Number(sourceArtworkGeometryInPixels.width) / Number(sourceArtworkGeometryInPixels.height);
  const destinationRatio = Number(printableAreaInInches.width) / Number(printableAreaInInches.height);

  const r = {
    artworkScaleFactor: null,
    artworkHeightInches: null,
    artworkWidthInches: null,
    artworkHeightPixels: null,
    artworkWidthPixels: null,
  };

  if (sourceRatio >= destinationRatio) {
    // Width constrained
    r.artworkScaleFactor = Number(printableAreaInInches.width) / Number(sourceArtworkGeometryInPixels.width);
    r.artworkWidthInches = Number(printableAreaInInches.width);
    r.artworkHeightInches = Number(sourceArtworkGeometryInPixels.height) * r.artworkScaleFactor;
    r.artworkWidthPixels = r.artworkWidthInches * Number(canvasPixelsPerInch);
    r.artworkHeightPixels = r.artworkHeightInches * Number(canvasPixelsPerInch);
  } else {
    // Height constrained
    r.artworkScaleFactor = Number(printableAreaInInches.height) / Number(sourceArtworkGeometryInPixels.height);
    r.artworkHeightInches = Number(printableAreaInInches.height);
    r.artworkWidthInches = Number(sourceArtworkGeometryInPixels.width) * r.artworkScaleFactor;
    r.artworkHeightPixels = r.artworkHeightInches * Number(canvasPixelsPerInch);
    r.artworkWidthPixels = r.artworkWidthInches * Number(canvasPixelsPerInch);
  }

  return r;
}

export function format(geometry) {
  const width = Number(geometry.artworkWidthInches).toLocaleString(undefined, { style: "decimal", maximumFractionDigits: 1 });
  const height = Number(geometry.artworkHeightInches).toLocaleString(undefined, { style: "decimal", maximumFractionDigits: 1 });
  return `${width}″ ✕ ${height}″`;
}
